import Utils from "../../services/Utils.js";
import { getLiveGames } from "../../js/api/inPlay.js";
import { getLiveSports } from "../../js/api/liveSports.js";
import {
  getLiveTemplate,
  getLiveTemplateEvent,
} from "../templates/live-games.js";
import { _t } from "../../services/TranslationService.js";
import { sports } from "../components/Leftpanel.js";
var mainLeagues = [];
let getSportValueId = 1;
let timers = [];
let market_type = 1;
let clickInProgress = false;
let Games = {
  render: async () => {
    const blockedSports = JSON.parse(localStorage.getItem('blockedSports') ?? '[]');
    const sport_id = 1;
    const blockedFootball = blockedSports.indexOf(sport_id.toString()) !== -1;

    let request = Utils.parseRequestURL();

    getSportValueId = request.id;


    // let liveSports = await getLiveSports();
    if (localStorage.getItem("inplay-sportid")) {
      getSportValueId = localStorage.getItem("inplay-sportid");
      localStorage.removeItem("inplay-sportid");
    }
    let games = blockedFootball ? '' : await renderGames(true);


    // getLiveSports().then((value) => {

    //   document.getElementById("liveSportsItem").innerHTML = "";
    //   for (let index = 0; index < value.length; index++) {
    //     const liveSport = value[index];
    //     document.getElementById("liveSportsItem").innerHTML =
    //       document.getElementById("liveSportsItem").innerHTML +
    //       `<a sportid="${liveSport.id}" class="betModuleSportBtn ${liveSport.id === 1 ? 'current' : ''} ${liveSport.is_active != 0 ? 'active' : ''}  hd-${liveSport.name}">
    //         <i class="sport-${liveSport.name}"></i>
    //         <span>${liveSport.name}</span>
    //        </a>`;
    //   }


    //   let sportsMatchWidth = 0;
    //   $("body .sportsLanding")
    //     .children(".betModuleTabs")
    //     .children(".betModuleTabsBtn")
    //     .children(".betModuleSportBtn")
    //     .each(function () {
    //       sportsMatchWidth += $(this).outerWidth(true);
    //     });
    //   $("body .sportsLanding .betModuleTabs").css({
    //     width: sportsMatchWidth - 15 + "px",
    //   });
    // });
    let liveSports = await getLiveSports();
    // const sportsInTaps = [
    //   { id: 1, name: _t('Futboll'), icon: '<i class="sport-soccer"></i>' },
    //   { id: 2, name: _t('Basketboll'), icon: '<i class="sport-basketball"></i>' },
    //   { id: 20, name: _t('Ping Pong'), icon: '<i class="sport-table-tennis"></i>' },
    // ].filter(sport => !blockedSports.includes(sport.id.toString()));

    const sportsInTabs = liveSports.filter(sport => sport.is_active == 1 && !blockedSports.includes(sport.id.toString())).map((sport, i) => {
      return `<a href="#" class="in-play-header-tab ${i === 0 ? 'active' : ''}" sportid="${sport.id}"><i class="sport-${sport.id}"></i> ${sport.name}</a>`
    }).join('');

    let view = /*html*/ `
        <div class="in-play-header-tabs">
          ${sportsInTabs ?? ''}
        </div>
        <div id="inPlayMainContentHolder">
        ${games}</div>
       `;
    return view;
  },
  after_render: async (socket) => {
    socket.emit('connectToRoom', { room: "inplay" });

    fix();
    // socket.on("new-live-game", (data) => {
    //     if (data.league == leagueId) {
    //         const game = document.getElementById(data.id);

    //         if (!game) {
    //             let liveGameContainer = document.getElementById("pre-match-games");
    //             if (liveGameContainer) {
    //                 const template = getLiveTemplate(data);
    //                 liveGameContainer.innerHTML =
    //                     liveGameContainer.innerHTML + template;
    //             }
    //         } else {
    //             game.innerHTML = getLiveTemplate(data);
    //         }
    //     }
    // });

    socket.on("new-live-game", (data) => {
      if (data.sport_id == getSportValueId) {
        const liveGame = document.getElementById(data.id);
        
        if (!liveGame) {
          const liveGameContainer = document.getElementById("pre-match-games");
          const leagueId = mainLeagues.find((a) => a.name == data.league);
          if (leagueId) {
            const leagueContent = document.getElementsByClassName(
              leagueId.leagueId
            );
            const template = getLiveTemplateEvent(data);
            if (leagueContent && leagueContent[0]) {
              if (liveGameContainer) {
                leagueContent[0].innerHTML += template;
              }
            } else {
              if (liveGameContainer) {
                liveGameContainer.innerHTML += ` <div class="gameTableContent">
                    <div class="singleGameDateLabel">
                      <span>${data.league} </span>
                      <span>1</span>
                      <span>X</span>
                      <span>2</span>
                    </div>
                    <div class="contentSingleGameHolder" id="pre-match-games">
                      ${template}
                    </div>
                </div>`;
              }
            }

            const check = timers.find((a) => a.game_id == data.id);
            if (!check) {
              const timerId = setInterval(() => liveTimer(`${data.id}-timer`), 1000);
              timers.push({ game_id: data.id, timerId });
            }
          }
        } else {
          const newTemplate = getLiveTemplateEvent(data);
          if (newTemplate) liveGame.innerHTML = newTemplate;
        }

        fix();
      }
    });

    $('.in-play-header-tabs .in-play-header-tab').unbind('click');
    $('.in-play-header-tabs .in-play-header-tab').on('click', async function(e) {
      e.preventDefault();

      const sportId = $(e.currentTarget).attr("sportid");
      // if ($(e.currentTarget).hasClass('active')) {
      //   return;
      // }

      $('.in-play-header-tabs .in-play-header-tab.active').removeClass('active');
      $(`.in-play-header-tabs .in-play-header-tab[sportid=${sportId}]`).addClass('active');

      getSportValueId = sportId;
      const view = await renderGames();
      document.getElementById("inPlayMainContentHolder").innerHTML = view;
      
      themeChange(sportId);
      
      if ( (getSportValueId == 1 || !getSportValueId)) {
        if (market_type == 3) {
          $('body').addClass('goalAnotherType');
        }
        renderCoefs();
      } else {
        $('body').removeClass('goalAnotherType');
      }
      bindDropdown();
    });

    $("body").on("click", ".betModuleSportBtn", async function (e) {
      if (clickInProgress === true) return;

      clickInProgress = true;
      const sportId = $(e.currentTarget).attr("sportid");
      if ($(e.currentTarget).hasClass('active')) {
        getSportValueId = sportId;

        const view = await renderGames();
        document.getElementById("inPlayMainContentHolder").innerHTML = view;
      }

      clearTimers();
      themeChange(sportId);
      
      if ( (getSportValueId == 1 || !getSportValueId)) {
        if (market_type == 3)
          $('body').addClass('goalAnotherType');
        renderCoefs();
      } else {
        $('body').removeClass('goalAnotherType');
      }
      clickInProgress = false;
    });

    $("body .menuItem a").removeClass("active");
    $("body .mainLeftMenuItem a").removeClass("active");
    $("body #inPlayPage").addClass("active");
    $("body .leftMenuInPlay").addClass("active");

    let sportsMatchWidth = 0;
    $("body .sportsLanding")
      .children(".betModuleTabs")
      .children(".betModuleTabsBtn")
      .children(".betModuleSportBtn")
      .each(function () {
        sportsMatchWidth += $(this).outerWidth() + 15;
      });
    $("body .sportsLanding .betModuleTabs").css({
      width: sportsMatchWidth - 3 + "px",
    });
    renderCoefs();
    bindDropdown();

    themeChange(getSportValueId ?? 1);
    $("body #inPlayPage").on('click', function() {
      if (location.hash === '#/InPlay') {
        location.reload();
      }
    })


    let sportId = $('#inPlayMainContentHolder').attr('sportid');
    // console.log('Sport ID', sportId);

    if (sportId && !isNaN(sportId)) {
      $('.in-play-header-tab.active').removeClass('active');
      $('.in-play-header-tab[sportid="' + sportId + '"]').addClass('active');
    }
  },
  on_unload: async (socket) => {
    socket.emit('leaveRoom', { room: "inplay" });
    clearTimers();
  },
};

function renderCoefs() {
  if (market_type == 3) {
    $('.singleGameDateLabelFirst').text(_t('Lart'));
    $('.singleGameDateLabelSecond').text(_t('Poshtë'));
    $('.singleGameDateLabelThird').text('');

    $('.singleGameDateLabelFirst').removeClass('threeCoefs');
    $('.singleGameDateLabelFirst').addClass('twoCoefs');
    $('.singleGameDateLabelSecond').removeClass('threeCoefs');
    $('.singleGameDateLabelSecond').addClass('twoCoefs');
    $('.singleGameDateLabelThird').width('0');


    $('.singleHomeOdd').removeClass('threeCoefs');
    $('.singleHomeOdd').addClass('twoCoefs');
    $('.singleDrawOdd').removeClass('threeCoefs');
    $('.singleDrawOdd').addClass('twoCoefs');
    $('.singleAwayOdd').width('0');
  }else {
    $('.singleGameDateLabelFirst').text('1');
    $('.singleGameDateLabelSecond').text('X');
    $('.singleGameDateLabelThird').text('2');

    $('.singleGameDateLabelFirst').removeClass('twoCoefs');
    $('.singleGameDateLabelFirst').addClass('threeCoefs');
    $('.singleGameDateLabelSecond').removeClass('twoCoefs');
    $('.singleGameDateLabelSecond').addClass('threeCoefs');
    $('.singleGameDateLabelThird').removeClass('twoCoefs');
    $('.singleGameDateLabelThird').addClass('threeCoefs');


    $('.singleHomeOdd').removeClass('twoCoefs');
    $('.singleHomeOdd').addClass('threeCoefs');
    $('.singleDrawOdd').removeClass('twoCoefs');
    $('.singleDrawOdd').addClass('threeCoefs');
    $('.singleAwayOdd').removeClass('twoCoefs');
    $('.singleAwayOdd').addClass('threeCoefs');


  }
}

function themeChange(sportId) {
//   console.log('Change Theme: ', sportId);
  $('#inPlayMainContentHolder').attr('sportid', sportId);
  if (sportId == 0) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body #pre-match-games").removeClass('twoColumn');
  }
  if (sportId == 1) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body #pre-match-games").removeClass('twoColumn');
  }
  if (sportId == 2) {
    $("body .betModuleHeaderContainer").removeClass("p-bg");
    $("body .betModuleHeaderContainer").addClass("o-bg");
    $("body #pre-match-games").addClass('twoColumn');
    $('.singleGameDateLabelFirst').removeClass('threeCoefs');
    $('.singleGameDateLabelSecond').removeClass('threeCoefs');
    $('.singleGameDateLabelThird').removeClass('threeCoefs');
  }
  // Tennis
  if (sportId == 5) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").addClass("p-bg");
    $("body #pre-match-games").addClass('twoColumn');
    $('.singleGameDateLabelFirst').removeClass('threeCoefs');
    $('.singleGameDateLabelSecond').removeClass('threeCoefs');
    $('.singleGameDateLabelThird').removeClass('threeCoefs');
  }
  // Table Tennis
  if (sportId == 20) {
    $("body .betModuleHeaderContainer").removeClass("o-bg");
    $("body .betModuleHeaderContainer").addClass("b-bg");
    $("body #pre-match-games").addClass('twoColumn');
    $('.singleGameDateLabelFirst').removeClass('threeCoefs');
    $('.singleGameDateLabelSecond').removeClass('threeCoefs');
    $('.singleGameDateLabelThird').removeClass('threeCoefs');
  }

  if (sportId) {
    setTimeout(() => {
      if ($('.betModuleSportBtn[sportid="' + sportId + '"]').hasClass('active')) {
        $('body .betModuleSportBtn').removeClass('current');
        $('.betModuleSportBtn[sportid="' + sportId + '"]').addClass('current');;
      }
    }, 300);
  }
}

function liveTimer(id) {
  const current_minute = $(`#${id}`).text();
  if (!current_minute || current_minute == "" || current_minute == "45:00")
    return;
  let minutes = parseInt(current_minute.split(":")[0]);
  let seconds = parseInt(current_minute.split(":")[1]);

  if (seconds == 59) {
    minutes += 1;
    seconds = 0;
  } else seconds += 1;

  $(`#${id}`).text(
    `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds
    }`
  );
}

async function renderGames(firstTime = false) {
  let games = await getLiveGames(getSportValueId, market_type);
  const uniqueLeagues = [
    ...new Set(games.map((item) => item.league_id)),
  ];

//   console.log(games);
  let gamesView = "";

  uniqueLeagues.forEach((leagueId) => {
    let singleDateView = "";
    let leagueName = "";

    games
      .filter((a) => a.league_id === leagueId)
      .map((game) => {
        
        if (!game.odd || game.id == 372481) {
          return;
        }
        leagueName = game.league;
        singleDateView += getLiveTemplate(game, (getSportValueId && getSportValueId != 1) ? 1 : market_type);
        if (game.sport_id != 5) {
          const check = timers.find((a) => a.game_id == game.id);
          if (!check) {
            const timerId = setInterval(() => liveTimer(`${game.id}-timer`), 1000);
            timers.push({ game_id: game.id, timerId });
          }
        }


      });
    gamesView =
      gamesView +
      ` <div class="gameTableContent ${leagueId}">
              <div class="singleGameDateLabel">
                 <span>${leagueName} </span>
                 <span class="singleGameDateLabelFirst">1</span>
                 <span class="singleGameDateLabelSecond">X</span>
                 <span class="singleGameDateLabelThird">2</span>
              </div>
              <div class="contentSingleGameHolder" id="pre-match-games">
                ${singleDateView}
              </div>
          </div>`;

    mainLeagues.push({
      leagueId: leagueId,
      name: leagueName,
    });
  });

  if (gamesView === "") {
    // gamesView = "<h3 class='noChildrenFound'>Nuk ka ndeshje per momentin!</h3>";
    gamesView = ""

  }
  if (!firstTime) {
    getLiveSports().then((value) => {
      let liveSportsView = "";
      value.forEach((liveSport) => {
        liveSportsView =
          liveSportsView +
          `<a sportid="${liveSport.id}" class="betModuleSportBtn ${liveSport.id === 1 ? 'current' : ''} ${liveSport.is_active != 0 ? 'active' : ''} hd-${liveSport.name}">
            <i class="sport-${liveSport.name}"></i>
            <span>${liveSport.name}</span>
           </a>`;
      });

      document.getElementById("liveSportsItem").innerHTML = liveSportsView;
    });
    let sportsMatchWidth = 0;
    $("body .sportsLanding")
      .children(".betModuleTabs")
      .children(".betModuleTabsBtn")
      .children(".betModuleSportBtn")
      .each(function () {
        sportsMatchWidth += $(this).outerWidth() + 15;
      });
    $("body .sportsLanding .betModuleTabs").css({
      width: sportsMatchWidth - 3 + "px",
    });
  }

  // let posts = await getPostsList()
  let view = /*html*/ `
      <div class="betModule liveInModule">
         <div class="betModule liveInModule sportsLanding" style="display: none !important">
           <div class="betModuleTabs">
             <div class="betModuleTabsBtn" id="liveSportsItem">

             </div>
           </div>
         </div>
         <div class="betModuleHeaderContainer">
           <div class="betModuleHeaderBtn">
               <input type="text" class="searchModule" placeholder="${_t('Kerko Ndeshjen')}">
           </div>
           ${!getSportValueId || getSportValueId == 1 ? ` <div class="dropdownWrapper">
           <div class="dropdownSelectedLabel">${market_type == 1 ? _t('Rezultat Final') : market_type == 2 ? _t("Goli i rradhes") : _t(`Golat`)}</div>
           <div class="dropdownContentItem">
               <a class="dropdownItemLinks ${market_type == 1 ? 'active' : ""}" data-id="1">${_t('Rezultat Final')}</a>
               <a class="dropdownItemLinks ${market_type == 2 ? 'active' : ""}" data-id="2">${_t('Goli i rradhes')}</a>
               <a class="dropdownItemLinks ${market_type == 3 ? 'active' : ""}" data-id="3">${_t('Golat')}</a>
<!--                    <a class="dropdownItemLinks">Match Goals</a>-->
<!--                    <a class="dropdownItemLinks">Rest of the Match</a>-->
           </div>
      </div>` : ""}

         </div>
       </div>
       <div class="gameTableContent searchLabeled">
          <div class="singleGameDateLabel hide">
             <span>${_t('Search')}: <i class="searchLabel"></i></span>
             <span>1</span>
             <span>X</span>
             <span>2</span>
          </div>
        </div>
         <div class="betModuleTabs">
           <div class="betModuleTabsBtn">
               <div id="pre-match-games">
              ${gamesView}
              </div>
           </div>
         </div>
       </div>
     `;

  fix();
  return view;
}

function fix() {
  // let sportsMatchWidth = 0;
  // $("body .sportsLanding")
  //   .children(".betModuleTabs")
  //   .children(".betModuleTabsBtn")
  //   .children(".betModuleSportBtn")
  //   .each(function () {
  //     sportsMatchWidth += $(this).outerWidth() + 15;
  //   });
  // $("body .sportsLanding .betModuleTabs").css({
  //   width: sportsMatchWidth - 3 + "px",
  // });

  $("body .searchModule").unbind("keyup");
  $("body .searchModule").bind("keyup", function (e) {
    let searchValue = $(e.currentTarget).val().toLowerCase();
    $(".betModuleTabs .gameTableContent ").each(function () {
      let singleTableSelector = $(this);

      $(this).children('.contentSingleGameHolder').children('.singleGameContent').each(function (i, item) {
        // console.log(item, i);
        if (
          $(this).children('.singleTeamNames').children('.singleDetailsColumn').children('.singleTeamRowLabel').children('.singleHomeName').text().toLowerCase().includes(searchValue) ||
          $(this).children('.singleTeamNames').children('.singleDetailsColumn').children('.singleTeamRowLabel').children('.singleAwayName').text().toLowerCase().includes(searchValue)
        ) {
          $(this).removeClass("notMatched");
        } else {
          $(this).addClass("notMatched");
        }
      });
      if (
        $(this)
          .children(".contentSingleGameHolder")
          .children(".singleGameContent.notMatched").length ==
        $(this)
          .children(".contentSingleGameHolder")
          .children(".singleGameContent").length
      ) {
        $(singleTableSelector).addClass("notChildrenMatched");
      } else {
        $(singleTableSelector).removeClass("notChildrenMatched");
      }
    });
    if (searchValue.length == 0) {
      $("body .searchLabeled")
        .children(".singleGameDateLabel")
        .addClass("hide");
      $(".betModuleTabsBtn").removeClass("searchingContent");
    } else {
      $("body .searchLabeled")
        .children(".singleGameDateLabel")
        .removeClass("hide");
      $(".betModuleTabsBtn").addClass("searchingContent");
    }
    $("body .searchLabel").text(searchValue);
  });

}

function clearTimers() {
  if (!timers || (timers && timers.length === 0)) return;

  for (let i = 0; i < timers.length; i++) {
    const timer = timers[i];
    clearInterval(timer.timerId);
  }
  timers = [];
}

function bindDropdown() {
  $('body .dropdownSelectedLabel').unbind('click');
  $('body .dropdownSelectedLabel').on('click', function (e) {
    let dropdownItem = $(e.currentTarget).siblings('.dropdownContentItem').children('.dropdownItemLinks').length;

    if ($(this).parent().hasClass('expand')) {
      $(e.currentTarget).parent().removeClass('expand');
      $(e.currentTarget).siblings('.dropdownContentItem').css({
        'height': 0 + 'px'
      });
    } else {
      $(e.currentTarget).parent().addClass('expand');
      $(e.currentTarget).siblings('.dropdownContentItem').css({
        'height': dropdownItem * 40 + 'px'
      });
    }
  });

  $('body .dropdownItemLinks').unbind('click');
  $('body .dropdownItemLinks').on('click', async function (e) {
    let getLabelValue = $(this).text();
    let getSelectValue = $(this).attr('data-id');

    if( getSelectValue == 3 ){
      $('body').addClass('goalAnotherType');
    }else {
        $('body').removeClass('goalAnotherType');
    }

    $('.dropdownItemLinks').removeClass('active');
    $(e.currentTarget).addClass('active');

    $('.dropdownSelectedLabel').text(getLabelValue);

    market_type = getSelectValue;
    const view = await renderGames(false);
    document.getElementById("inPlayMainContentHolder").innerHTML = view;

    $('.dropdownSelectedLabel').parent().removeClass('expand');
    $('.dropdownSelectedLabel').siblings('.dropdownContentItem').css({
      'height': 0 + 'px'
    });

    renderCoefs();
    bindDropdown();
  });
}
export default Games;
